import { render, staticRenderFns } from "./MyMetrics.vue?vue&type=template&id=dc3d29f0"
import script from "./MyMetrics.vue?vue&type=script&lang=js"
export * from "./MyMetrics.vue?vue&type=script&lang=js"
import style0 from "./MyMetrics.vue?vue&type=style&index=0&id=dc3d29f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports